import useSWR, { type SWRConfiguration } from 'swr';
import { getAccessCodeById } from '@/api/accessCode';
import { QueryKey } from '@/api/queryKey';

export const useAccessCodeById = (id?: string, config?: SWRConfiguration) => {
  const { data, isLoading, isValidating, error, mutate } = useSWR(
    () => QueryKey.GetAccessCodeById(id),
    () => getAccessCodeById(id),
    config
  );

  return {
    data: data ?? null,
    isLoading,
    isValidating,
    isReady: !isLoading && !isValidating && !error,
    error,
    mutate,
  };
};
